var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcFinePrintPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "12px",
    viewBox: "0 0 17 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_finePrint_preview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spec",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-28.000000, -25.000000)",
    fill: "#6A747F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7734276,29.6849315 L45,30.9794521 L39.2430232,37 L35.5039557,33.1369863 L36.7305281,31.8630137 L39.2430232,34.4315068 L43.7734276,29.6849315 Z M28.0272891,33 L28.0272891,31 L34,31 L34,33 L28.0272891,33 Z M38,25 L38,27 L28.003864,27 L28.003864,25 L38,25 Z M38,28 L38,30 L28,30 L28,28 L38,28 Z",
    id: "ic_finePrint_preview"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFinePrintPreview);
export default __webpack_public_path__ + "static/media/ic_finePrint_preview.44490f2c766abd4a7b54a0e1622cebbe.svg";
export { ForwardRef as ReactComponent };